<!-- Dismiss Alert for the instruction is specifically configured for OAUTH2 connection methods like Clio -->
<glxy-alert
  type="info"
  [showClose]="integration()?.connectionMethod === connectionMethods.OAUTH2"
  [ngClass]="{ hidden: dismissed }"
  (close)="dismissInstruction()"
>
  <span
    ><b>{{ instructions().title }}</b></span
  >
  <ng-container>
    @for (instruction of instructions().fields; track $index) {
      @switch (instruction.fieldType) {
        @case (fieldType.FIELD_TYPE_PASSWORD) {
          <div [innerHTML]="instruction.label"></div>
          <div>
            <platform-integration-passwordfield
              [isInstructionPage]="true"
              [disabled]="instruction.readonly"
              [value]="getFieldValue(instruction)"
              [placeholder]="instruction.placeHolder"
            ></platform-integration-passwordfield>
          </div>
        }
        @case (fieldType.FIELD_TYPE_LABEL) {
          <platform-integration-labelfield
            [field]="instruction"
            [connection]="connection()"
          ></platform-integration-labelfield>
        }
        @case (fieldType.FIELD_TYPE_URL) {
          <platform-integration-urlfield [field]="instruction"></platform-integration-urlfield>
        }
      }
    }
  </ng-container>
</glxy-alert>
